import { 
  FETCH_MERCHANTS_BY_COUNTRY_REQUEST, 
  FETCH_MERCHANTS_BY_COUNTRY_SUCCESS, 
  FETCH_MERCHANTS_BY_COUNTRY_FAILURE, 
  CLEAR_MERCHANTS_BY_COUNTRY,
} from '../actions/merchantsByCountry';

const defaultState = {
  loading: false,
  loaded: false,
  items: [],
};

export default function orders(state = defaultState, action) {

  switch (action.type) {
    case CLEAR_MERCHANTS_BY_COUNTRY:
      return {
        ...state,
        defaultState
      };
    case FETCH_MERCHANTS_BY_COUNTRY_REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_MERCHANTS_BY_COUNTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        items: [...action.payload.items],
        country: action.payload.country,
        lastUpdated: action.payload.receivedAt,
      };
    case FETCH_MERCHANTS_BY_COUNTRY_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}